import { useDispatch, useSelector } from 'react-redux';
import { useRef } from 'react';
import { useButton } from 'react-aria';

import { LOCALES } from 'i18n/locales';
import { useIntl } from 'react-intl';

import defaultAriaProps from 'client/utils/constants/ariaPropTypes';

import styles from './SelectLocale.module.scss';
import useAuth from 'client/utils/auth/useAuth';
import { manageLocaleChange } from 'client/utils/i18n/i18nUtils';

const SelectLocale = ({ ...props }) => {
    const dispatch = useDispatch();
    const { isAuthenticated } = useAuth();
    const currentLocale = useSelector(state => state?.locale?.current);
    const intl = useIntl();

    const ref = useRef();
    const { buttonProps } = useButton({
        ...props,
        elementType: 'a',
        onPress: () => manageLocaleChange(currentLocale, isAuthenticated, dispatch),
        'aria-label': intl.formatMessage({ id: 'footer.link.selectLocale.ariaLabel' })
    }, ref);

    return (
        <li
            className="govuk-footer__inline-list-item"
        >
            <a
                ref={ref}
                {...buttonProps}
                className={['govuk-link', 'govuk-link--no-visited-state', 'govuk-footer__link', styles.link].join(' ')}
                data-testid={props['data-testid'] ? props['data-testid'] : null}
                lang={currentLocale === LOCALES.WELSH ? LOCALES.ENGLISH : LOCALES.WELSH }
            >
                {intl.formatMessage({ id: 'footer.link.selectLocale' }) }
            </a>
        </li>
    );
};

SelectLocale.propTypes = {
    ...defaultAriaProps
};

export default SelectLocale;
